// extracted by mini-css-extract-plugin
export default {"menuWrapper":"Menu_menuWrapper__vw0uF"};